import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { ShippingForm } from "@/features/dashboard/transportadoras/components/ShippingForm";

export const Route = createFileRoute("/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar nova Transportadora" from="/dashboard/transportadoras/cadastrar">
      <ShippingForm />
    </BaseEditCreateModal>
  )
});
